export const clientConfig: Record<string, {
    hostname: string
    url: string
    urlBack: string
    telephone: string
    favicon: string
    favicon_alt: string
    title: string
    description: string
    facebook: string
    instagram: string
    tiktok: string
}> = {
    //
    "": {
        'hostname': "",
        "url": "",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '',
        "favicon": "/image/cache/catalog/         /logo/100_100_              .png",
        "favicon_alt": "",
        "title": "",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    'abikebab': {
        'hostname': 'abikebab.fr',
        'url': 'https://abikebab.fr',
        'urlBack': 'https://back.abikebab.fr',
        'telephone': '04.75.80.38.79',
        "favicon": "/image/cache/catalog/43/logo/100_100_abi_logo.png",
        "favicon_alt": "Logo ABI KEBAB",
        "title": "ABI KEBAB NAN TACOS",
        "description": "Dispose d'une terrasse · Propose un menu enfant · Chiens autorisés à l'extérieur",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    // 
    "Test O'King": {
        'hostname': 'localhost:5173',
        'url': 'https://localhost:5173',
        'urlBack': 'https://back.eronor.eu',
        'telephone': '01.02.03.04.05',
        "favicon": "/image/cache/catalog/15/logo/100_100_oking_logo.png",
        "favicon_alt": "Logo Test O'King",
        "title": "Test O'King",
        "description": "Dispose d'une terrasse · Propose un menu enfant · Chiens autorisés à l'extérieur",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Test Eronor": {
        'hostname': 'dev.eronor.eu',
        'url': 'https://dev.eronor.eu',
        'urlBack': 'https://back.eronor.eu',
        'telephone': '01.02.03.04.05',
        "favicon": "/image/cache/catalog/13/logo/100_100_gout_menthe.png",
        "favicon_alt": "Logo Test Eronor",
        "title": "Test Eronor",
        "description": "Dispose d'une terrasse · Propose un menu enfant · Chiens autorisés à l'extérieur",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Irfan Kebab": {
        'hostname': 'menuboard.fr',
        'url': 'https://menuboard.fr',
        'urlBack': 'https://back.eronor.eu',
        'telephone': '01.02.03.04.05',
        "favicon": "/image/cache/catalog/12/logo/100_100_gout_citron.png",
        "favicon_alt": "Logo Irfan Kebab",
        "title": "Irfan Kebab",
        "description": "Dispose d'une terrasse · Propose un menu enfant · Chiens autorisés à l'extérieur",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    // 
    "BEST KEBAB": {
        'hostname': "aubenas.bestkebabtacos.fr",
        "url": "https://aubenas.bestkebabtacos.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '0981357187',
        "favicon": "/image/cache/catalog/53/logo/100_100_logo_500.png",
        "favicon_alt": "",
        "title": "BEST KEBAB",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Best Rosières": {
        'hostname': "rosieres.bestkebabtacos.fr",
        "url": "https://rosieres.bestkebabtacos.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '01.02.03.04.05',
        "favicon": "/image/cache/catalog/56/logo/100_100_logo.png",
        "favicon_alt": "",
        "title": "Best Rosières",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "MONTILIEN KEBAB": {
        'hostname': "kebabmontelimar.fr",
        "url": "https://kebabmontelimar.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '0475923616',
        "favicon": "/image/cache/catalog/54/logo/100_100_logo3.png",
        "favicon_alt": "",
        "title": "MONTILIEN KEBAB",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Aux Delices": {
        'hostname': "auxdeliceskebab.fr",
        "url": "https://auxdeliceskebab.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '04 75 98 67 66',
        "favicon": "/image/cache/catalog/55/logo/100_100_logotiny.png",
        "favicon_alt": "",
        "title": "Aux Delices",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Planete Pierrelatte": {
        'hostname': "kebabpierrelatte.fr",
        "url": "https://kebabpierrelatte.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '04 75 46 27 83',
        "favicon": "/image/cache/catalog/39/logo/100_100_planete_w_lg.webp",
        "favicon_alt": "",
        "title": "Planete Pierrelatte",
        "description": "",
        "facebook": "https://www.facebook.com/tacos.naan.kebab",
        "instagram": "",
        "tiktok": ""
    },
    "O'Délice by MKF": {
        'hostname': "odelice.webcommande.fr",
        "url": "https://odelice.webcommande.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '04 27 59 97 70',
        "favicon": "/image/cache/catalog/27/logo/100_100_images2.png",
        "favicon_alt": "",
        "title": "O'Délice Fast Food",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Kebab House": {
        'hostname': "kebabhousevalence.fr",
        "url": "https://kebabhousevalence.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '0475598851',
        "favicon": "/image/cache/catalog/5/logo/100_100_logo_kebab_house.png",
        "favicon_alt": "",
        "title": "Kebab House",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Resto Time": {
        'hostname': "restotime.webcommande.fr",
        "url": "https://restotime.webcommande.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '09 55 20 07 44',
        "favicon": "/image/cache/catalog/23/logo/100_100_logo_1_1.png",
        "favicon_alt": "",
        "title": "Resto Time",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "O'King": {
        'hostname': "okingkebab.fr",
        "url": "https://okingkebab.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '04 75 79 08 72',
        "favicon": "/image/cache/catalog/15/logo/100_100_oking_logo.png",
        "favicon_alt": "",
        "title": "O'King Kebab Naan Tacos",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Caprice Kebab": {
        'hostname': "capricekebab.webcommande.fr",
        "url": "https://capricekebab.webcommande.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '0475441219',
        "favicon": "/image/cache/catalog/47/logo/100_100_logorondnoir.png",
        "favicon_alt": "",
        "title": "Caprice Kebab",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Kebab World": {
        'hostname': "kebabworld.fr",
        "url": "https://kebabworld.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '0955818752',
        "favicon": "/image/cache/catalog/20/logo/100_100_logo_kebab_world_contour_blanc.png",
        "favicon_alt": "",
        "title": "Kebab World",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "L'Art Des Choix": {
        'hostname': "lartdeschoix07.fr",
        "url": "https://lartdeschoix07.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '0475800554',
        "favicon": "/image/cache/catalog/48/logo/100_100_logorondeart.png",
        "favicon_alt": "",
        "title": "L'Art Des Choix",
        "description": "",
        "facebook": "https://www.facebook.com/profile.php?id=100092044800789",
        "instagram": "",
        "tiktok": ""
    },
    "The Best Authentic": {
        'hostname': "thebestauthentic.fr",
        "url": "https://thebestauthentic.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '04 74 77 65 85',
        "favicon": "/image/cache/catalog/24/logo/100_100_best_authantic_logo_2.png",
        "favicon_alt": "",
        "title": "The Best Authentic",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "Mis Kebab Valence": {
        'hostname': "miskebab.webcommande.fr",
        "url": "https://miskebab.webcommande.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '0952890933',
        "favicon": "/image/cache/catalog/19/logo/100_100_logo2.png",
        "favicon_alt": "",
        "title": "Mis Kebab Valence",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
    "MK Resto": {
        'hostname': "mkresto.fr",
        "url": "https://mkresto.fr/",
        "urlBack": "https://back.abikebab.fr",
        'telephone': '09 61 61 29 78',
        "favicon": "/image/cache/catalog/41/logo/100_100_logopni.png",
        "favicon_alt": "",
        "title": "MK Resto",
        "description": "",
        "facebook": "",
        "instagram": "",
        "tiktok": ""
    },
}